import { DecimalPipe } from '@angular/common';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'checkdecimal',
})
export class CheckdecimalPipe extends DecimalPipe {
  transform(value: number): any {
    if (isNaN(value) === false && value !== 0) {
      return super.transform(value);
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/app/checkdecimal.pipe.ts